import React from 'react';
import { colors } from '../../theme';
import { Phone, Lock } from 'lucide-react';

export default function CallProtocolPicker({ onSip, onE2ee, onClose, capabilities }) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)' }} onClick={onClose} />
      <div style={{ position: 'relative', width: '100%', maxWidth: 400, background: colors.white, borderRadius: '20px 20px 0 0', padding: '24px 20px', paddingBottom: 'max(24px, env(safe-area-inset-bottom))' }}>
        <div style={{ width: 40, height: 4, borderRadius: 2, background: colors.gray200, margin: '0 auto 20px' }} />
        <div style={{ fontSize: 17, fontWeight: 600, textAlign: 'center', marginBottom: 20, color: colors.gray900 }}>Выберите тип звонка</div>
        {capabilities.includes('sip') && (
          <button onClick={onSip} style={{ display: 'flex', alignItems: 'center', gap: 14, width: '100%', padding: '14px 16px', border: '1px solid ' + colors.gray200, borderRadius: 14, background: colors.gray100, cursor: 'pointer', marginBottom: 10 }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, background: 'rgba(79,182,140,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Phone size={20} color="#4fb68c" />
            </div>
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontSize: 15, fontWeight: 600, color: colors.gray900 }}>Обычный звонок</div>
              <div style={{ fontSize: 12, color: colors.gray400, marginTop: 2 }}>SIP через Asterisk</div>
            </div>
          </button>
        )}
        {capabilities.includes('e2ee') && (
          <button onClick={onE2ee} style={{ display: 'flex', alignItems: 'center', gap: 14, width: '100%', padding: '14px 16px', border: '1px solid ' + colors.gray200, borderRadius: 14, background: colors.gray100, cursor: 'pointer', marginBottom: 10 }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, background: 'rgba(110,138,208,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Lock size={20} color="#6e8ad0" />
            </div>
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontSize: 15, fontWeight: 600, color: colors.gray900 }}>Зашифрованный звонок</div>
              <div style={{ fontSize: 12, color: colors.gray400, marginTop: 2 }}>E2EE туннель, полное шифрование</div>
            </div>
          </button>
        )}
        <button onClick={onClose} style={{ display: 'block', width: '100%', padding: '12px', border: 'none', borderRadius: 12, background: colors.gray100, cursor: 'pointer', fontSize: 15, color: colors.gray500, marginTop: 4 }}>
          Отмена
        </button>
      </div>
    </div>
  );
}
